import React from "react";
import { motion } from "framer-motion";
import { useTr } from "@/autoTranslate";
import { useSiteContent } from "@/siteContent";

export default function Footer() {
  const tr = useTr();
  const site = useSiteContent();
  return (
    <footer
      data-testid="site-footer"
      className="relative px-6 md:px-10 pt-16 pb-8 bg-[color:var(--ink)] text-[color:var(--bone)]"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 border-b border-white/15 pb-16">
        <div className="md:col-span-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-15%" }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            className="display-sans text-6xl md:text-[10vw] leading-[0.85]"
          >
            duru<span className="text-[color:var(--chartreuse)]">.</span>
          </motion.div>
          <p className="mt-6 max-w-md opacity-80">
            {tr(site.get("footer.text"))}
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono-label text-[11px] uppercase tracking-widest opacity-70">
            {tr("Başka yerlerde")}
          </div>
          <ul className="mt-4 space-y-2 font-serif-editorial italic text-2xl">
            <li><a className="u-link" href={site.get("contact.linkedin")} target="_blank" rel="noreferrer">LinkedIn</a></li>
            <li><a className="u-link" href={`mailto:${site.get("contact.email")}`}>{tr("E-posta")}</a></li>
            <li><a className="u-link" href={`tel:${site.get("contact.phone").replace(/\s/g, "")}`}>{tr("Telefon")}</a></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono-label text-[11px] uppercase tracking-widest opacity-70">
            {tr("Künye")}
          </div>
          <ul className="mt-4 space-y-2 text-sm opacity-80">
            {site.getList("footer.colophon").map((line, i) => (
              <li key={i}>{tr(line)}</li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-8 flex items-center justify-between font-mono-label text-[10px] uppercase tracking-widest opacity-70 flex-wrap gap-4">
        <span>© {new Date().getFullYear()} · Duru Ünalan</span>
        <span>{tr("Ankara'da yapıldı · Bölümler biter. Web siteleri bitmez.")}</span>
      </div>
    </footer>
  );
}
